import { classInstance } from '@/shared/helpers/helpers';
import { ModalGalleryMain } from './modal-gallery-main/modal-gallery-main';
import { ModalGalleryThumbs } from './modal-gallery-thumbs/modal-gallery-thumbs';

export class ModalGalleryImages {
	private element: HTMLElement;
	private readonly modalElement: HTMLElement | null;
	private readonly mainElement: HTMLElement;
	private readonly thumbsElement: HTMLElement;
	private mainSlider: ModalGalleryMain;
	private thumbsSlider: ModalGalleryThumbs;
	private thumbsPrevButton: HTMLButtonElement;
	private thumbsNextButton: HTMLButtonElement;
	private openIndex = 0;

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.modalElement = this.element.closest('.modal-gallery');
		this.mainElement = this.element.querySelector('.modal-gallery-main');
		this.thumbsElement = this.element.querySelector('.modal-gallery-thumbs');
		this.thumbsPrevButton = this.thumbsElement.querySelector('.modal-gallery-thumbs__button--prev');
		this.thumbsNextButton = this.thumbsElement.querySelector('.modal-gallery-thumbs__button--next');

		this.init();
	}

	private handleThumbsPrevButtonClick = (): boolean => this.mainSlider.slider.slidePrev();
	private handleThumbsNextButtonClick = (): boolean => this.mainSlider.slider.slideNext();

	private handleModalOpen = (): void => {
		requestAnimationFrame(() => {
			this.slideTo(this.openIndex);
			this.mainSlider.slider.update();
			this.mainSlider.slider.navigation?.update();
		});
	};

	private parseIndex = (index: number | string | undefined): number => {
		const slideIndex = Number(index);

		return Number.isFinite(slideIndex) ? slideIndex : 0;
	};

	init = (): void => {
		this.thumbsSlider = new ModalGalleryThumbs(this.thumbsElement);
		this.mainSlider = new ModalGalleryMain(this.mainElement, this.thumbsSlider.slider);
		this.thumbsPrevButton.addEventListener('click', this.handleThumbsPrevButtonClick);
		this.thumbsNextButton.addEventListener('click', this.handleThumbsNextButtonClick);
		this.modalElement?.addEventListener('modalOpen', this.handleModalOpen);
		classInstance.set(this.element, { modalGalleryImages: this });
	};

	public setOpenIndex = (index: number | string | undefined): void => {
		this.openIndex = this.parseIndex(index);
	};

	public slideTo = (index: number | string = 0): void => this.mainSlider.slideTo(this.parseIndex(index));
}
